import React, { useEffect, useState } from 'react';

import './styles.css';

import { useParams } from 'react-router';

import classServices from '../../../services/academy/classServices';

import loadTextTest from '../../../functions/loadTextTest';
import compare from '../../../functions/compare';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import ClassProfileCard from './ClassProfileCard';
import ClassTrainingsCard from './ClassTrainingsCard';
import ClassCallListsCard from './ClassCallListsCard';
import ClassPaymentsCard from './ClassPaymentsCard';
import ClassNotificationsCard from './ClassNotificationsCard';
import ClassStudentsCard from './ClassStudentsCard';
import ActivityIndicator from '../../../components/ActivityIndicator';

export default function Class(props) {
    const params = useParams();
    const [classInfos, setClassInfos] = useState({});
    const [classStudents, setClassStudents] = useState([]);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        readClassInfos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    useEffect(() => {
        if (classInfos.id)
            readClassStudents();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classInfos.id])

    async function readClassInfos() {
        const response = await classServices.getClassInfos(params.id);
        setFetching(false);
        if (response.status === 200) {
            setClassInfos(response.data);
        } else
            alert("Erro ao ler turma, tente novamente!");
    }

    async function readClassStudents() {
        const response = await classServices.getClassStudents(classInfos.id);
        if (response.status === 200) {
            setClassStudents(response.data.sort((a, b) => compare(`${a.nome} ${a.sobrenome}`, `${b.nome} ${b.sobrenome}`)));
        } else
            alert("Erro ao ler turma do estudante, tente novamente!");
    }

    function onDelete(index, array = classStudents, setArray = setClassStudents) {
        setArray([...array.slice(0, index), ...array.slice(index + 1, array.length)]);
    }

    return (
        <MainView currentPage='classes' coachMenu={props.coachMode}>
            <NavHistory navPages={['Turmas', loadTextTest(classInfos.nome)]} />
            {
                !fetching ?
                    <div className='class-page-cards'>
                        <div className='class-page-cards-group'>
                            <ClassProfileCard classInfos={classInfos} coachMode={props.coachMode} />
                            <ClassTrainingsCard classId={classInfos.id} />
                            {
                                props.coachMode ?
                                    [] :
                                    <ClassCallListsCard classId={classInfos.id} classStudents={classStudents} />
                            }
                        </div>
                        <div className='class-page-cards-group'>
                            {
                                props.coachMode ?
                                    <ClassCallListsCard classId={classInfos.id} classStudents={classStudents} />
                                    : []
                            }
                            {
                                props.coachMode ?
                                    [] :
                                    <ClassPaymentsCard classId={classInfos.id} />
                            }
                            <ClassNotificationsCard
                                classId={classInfos.id}
                            />
                            <ClassStudentsCard
                                coachMode={props.coachMode}
                                classId={classInfos.id}
                                className={classInfos.nome}
                                classType={classInfos.tipo}
                                classAgeGroup={classInfos.faixa_etaria}
                                vacancies={classInfos.numero_vagas - classStudents.length}
                                classStudents={classStudents}
                                onUpdate={readClassStudents}
                                onDelete={onDelete}
                            />
                        </div>
                    </div>
                    : <ActivityIndicator />
            }
        </MainView>
    )
}